module.exports = __webpack_public_path__ + "img/0ecfd977b6290eb9ca2fa939bfddf2ba.png";